export default {"src":"/_next/static/media/sweden.b7f69dca.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};